import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "../components/Styles/home.css";
import {Helmet}from"react-helmet";

import second from "../assets/images/new1a (1).png";
import third from "../assets/images/new2 (1).png";
import fourth from "../assets/images/new3 (1).png";
import fifth from "../assets/images/1cc.png";
import wifi from "../assets/images/wifi.png";
import pantry from "../assets/images/pantry.png";
import printer from "../assets/images/printer.png";
import lounge from "../assets/images/lounge.png";
import helpdesk from "../assets/images/helpdesk.png";
import prooms from "../assets/images/prooms.png";
import dollor from "../assets/images/dollor.png";
import tea from "../assets/images/tea.png";
import msrooms from "../assets/images/mrooms.png";
import framee from "../assets/images/frame (1).png";

import AOS from "aos";
import "aos/dist/aos.css";
import Slide from "./Slide";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []);
   // ✅ FIX: add dependency array so it doesn't run every render
/* ✅ CTA + WHY icons (NEW) */
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

  return (
    <div>
      <Helmet>
      
      <title>Coworking Space in Houston, TX | Xceed Office – Flexible Workspaces in Texas</title>
      <meta name="description" content="Discover Xceed Office  premier coworking space in Houston, Texas. Flexible offices, dedicated desks, meeting rooms & business amenities designed for startups, freelancers, and growing teams in TX."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      <section className="main">
        <div className="main_sec">
          <h1>
            <span style={{ color: "#EEBD2B" }}>Executive Offices.</span>
            <br /> 
            Done Right.

          </h1>

          <p>Operate your business from a professional environment designed for credibility, focus, and flexibility. </p>

          <button> <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Private Tour</a>
          </button>{" "}
          <a href="https://xceed.nexudus.site/Xceed/checkout/tariffs?type=1&start=2026-07-07T19%3A00%3A00.000-05%3A00&end=2026-07-07T20%3A00%3A00.000-05%3A00">
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            View Office Options
          </button>
          </a>
        </div>
      </section>


<section style={{background:"#171717ff"}} className="ws">
  <div className="ws__container">
    <header className="ws__header">
      <h2 className="ws__title">Our Workspace Solutions</h2>
      <p className="ws__subtitle">Executive Workspace Solutions</p>
      <p className="ws__lead">
        Flexible options designed for growing companies and established professionals.
      </p>
    </header>

    <div className="ws__grid" role="list">
      <article className="ws-card" role="listitem">
        <div className="ws-card__imageWrap">
          <img className="ws-card__image" src={second} alt="Private Offices" />
        </div>
        <div className="ws-card__body">
          <h3 className="ws-card__title">Private Offices</h3>
          <p className="ws-card__text">
            Fully furnished executive suites in a Class A setting. Ideal for law firms,
            consultants, agencies, and professional teams who require privacy and presence.
          </p>
        </div>
      </article>

      <article className="ws-card" role="listitem">
        <div className="ws-card__imageWrap">
          <img className="ws-card__image" src={third} alt="Virtual Office" />
        </div>
        <div className="ws-card__body">
          <h3 className="ws-card__title">Virtual Office</h3>
          <p className="ws-card__text">
            Establish your business in a prestigious Houston address with mail handling,
            professional phone answering, and optional meeting access.
          </p>
        </div>
      </article>

      <article className="ws-card" role="listitem">
        <div className="ws-card__imageWrap">
          <img className="ws-card__image" src={fourth} alt="Conference & Day Offices" />
        </div>
        <div className="ws-card__body">
          <h3 className="ws-card__title">Conference &amp; Day Offices</h3>
          <p className="ws-card__text">
            Book fully equipped meeting rooms and private day offices for client
            presentations, interviews, and strategic sessions.
          </p>
        </div>
      </article>
    </div>
  </div>
</section>

       <section  className="exp">
      <div className="exp__container">
        <div className="exp__grid">
          {/* Left */}
          <div className="exp__content">
            <h2 className="exp__title">
              Designed for Focus.
              <br />
              <span className="exp__accent">Built for Growth.</span>
            </h2>

            <p className="exp__text">
              Walk your clients into a refined Class A building. Work in a quiet,
              professional environment that supports deep focus and strategic thinking.
              Every detail — from reception to meeting rooms — is designed to reflect
              credibility and confidence.
            </p>

            <p className="exp__text">
              Xceed Office is not a shared desk space. It’s a business environment
              structured for professionals who take their work seriously.
            </p>
          </div>

          {/* Right */}
          <div className="exp__media">
            <div className="exp__imageCard">
              <img
                className="exp__image"
                src={fifth}
                alt="Executive workspace lounge"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <br /><br />
  <section   className="main_sec3">
        <div>
          <div className="col_mlst">
            <h2>
              Why Choose <span style={{ color: "#EEBD2B" }}>Xceed Office?</span>
            </h2>
            <p style={{color:"white",marginTop:"2%"}}>
Executive-level amenities designed to support your business.            </p>
          </div>

          <br />

          <div className="row__sec__4">
            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={wifi} alt="High-speed WiFi" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>High-Speed Wifi</h3>
                  <p>
Enterprise-grade connectivity built for video calls, cloud systems, and uninterrupted productivity.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={pantry} alt="Pantry" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Virtual Office Services</h3>
                  <p>
 Prestigious business address, mail handling, and phone answering.
                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={printer} alt="Printer" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Business Support Services</h3>
                  <p>
Optional accounting, marketing, and administrative support to streamline operations.                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row__sec__4">
            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={lounge} alt="Lounge" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Meeting & Conference Rooms</h3>
                  <p>
Fully equipped spaces for presentations, negotiations, and collaboration.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={helpdesk} alt="Helpdesk" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Professional Reception</h3>
                  <p>
Live front desk support to greet your clients and manage deliveries.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={prooms} alt="Prayer Rooms" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Private Lounge & Pantry</h3>
                  <p>
Comfortable areas designed for networking and professional interaction.                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row__sec__4">
            <div id="hdd" className="coL__sec4">
              <div className="row__sec__sub">
                <div  className="coL__sec4__sub">
                  <img src={dollor} alt="Competitive Prices" />
                </div>
                <div  className="coL__sec4__sub2">
                  <h3>Competitive Prices</h3>
                  <p>
                    Access our premium amenities at competitive prices, ensuring
                    exceptional value without compromising quality
                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={tea} alt="Tea and Coffee" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Prayer Rooms</h3>
                  <p>
Private dedicated spaces for reflection and spiritual practice.                  </p>
                </div>
              </div>
            </div>

            <div id="hdd" className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={msrooms} alt="Meeting Rooms" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Meeting Rooms</h3>
                  <p>
                    Book our well-equipped meeting rooms for a professional
                    setting suited to discussions, presentations, and
                    collaboration
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
<br /><br />
 <section className="bfg">
  <div className="bfg__container">
    <div className="bfg__grid">
      {/* Left */}
      <div className="bfg__content">
        <h2 className="bfg__title">
          Built for <span>Growing</span>
          <br />
          <span>Companies</span>
        </h2>

        <p className="bfg__text">
          Whether you are launching a new venture or expanding your team, Xceed Office
          offers scalable solutions that grow with your business. Upgrade from virtual
          office to private suite. Expand into larger space as your team increases.
          Maintain flexibility without sacrificing image.
        </p>
      </div>

      {/* Right */}
      <div className="bfg__media">
        <div className="bfg__imageCard">
          <img className="bfg__image" src={framee} alt="Team meeting in office" />
        </div>
      </div>
    </div>
  </div>
</section>
   {/* ✅ CTA SECTION (ADDED) */}
      <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
              <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a><span className="cta__arrow">→</span>
            </button>
            <a href="tel:346-502-2552">
            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
            </a>
          </div>


        </div>
      </section>


    </div>
  );
};

export default Home;



